import { render, staticRenderFns } from "./SOCScreen3.vue?vue&type=template&id=44fc47ac"
import script from "./SOCScreen3.vue?vue&type=script&lang=js"
export * from "./SOCScreen3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports